// Centralized configuration for UI Web
export const DERIV_APP_ID = 12812;
